module.exports = __webpack_public_path__ + "static/img/RAPW600_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPW600_1.png
// module id = SeW6
// module chunks = 0